import React from 'react';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(() => ({
    width: '100%',
    padding: '6px 3.175%',
    alignItems: 'center',
    display: 'grid',
    borderBottom: '1px solid #ededed',
    gap: '10px',
}));

export const HeaderContentWrapper: React.FC<{
    children: React.ReactNode;
    columnNumner: number;
}> = (props) => {
    return (
        <>
            <StyledBox
                sx={{
                    gridTemplateColumns:
                        props.columnNumner == 2 ? '50% 50%' : '30% 35% 35%',
                }}
            >
                {props.children}
            </StyledBox>
        </>
    );
};
